<template>

	<transition-group 
		name="alert" 
		tag="div"
		enter-active-class="animate__animated animate__fadeIn animate__faster"
		leave-to-class="animate__animated animate__fadeOut animate__faster"
	> 
		<div key="1" class="featherlight" v-if="shouldShow==true" style="display: block;" v-on:click.self="toggleClaimForm()">
			<div class="featherlight-content" id="claim_form" >
				<button class="featherlight-close-icon featherlight-close" aria-label="Close" v-on:click.self="toggleClaimForm()">✕</button>
				<section class="popup_content featherlight-inner section" style="max-width: 45rem;">
					<div class="constraint">
						<h2>Enter your details</h2>
						<div class="form_style">
							<template v-if="errors != [] && errors != null && Object.keys(errors).length > 0">
								<template v-if="typeof errors == 'string'">
								<p class="error"><i class="fas fa-2x fa-exclamation-circle"></i> <span>{{ errors }}</span></p>
								</template>
								<template v-else>
									<p class="error"><i class="fas fa-2x fa-exclamation-circle"></i> <span>There was a problem with the form submission. Please check the errors below and try again.</span></p>
								</template>
							</template>
							<p>
								<label for="first_name" class="required">First Name</label>
								<input type="text" id="first_name" name="first_name" placeholder="Enter a first name" v-model="first_name" :class="{ error: errors.first_name }">
								<span v-if="errors.first_name" class="validation-error">{{ errors.first_name[0] }}</span>
							</p>

							<p>
								<label for="last_name" class="required">Last Name</label>
								<input type="text" id="last_name" name="last_name" placeholder="Enter a last name" v-model="last_name" :class="{ error: errors.last_name }">
								<span v-if="errors.last_name" class="validation-error">{{ errors.last_name[0] }}</span>
							</p>
							<p>
								<label for="contact_number">Contact Number</label>
								<input type="text" id="contact_number" name="contact_number" placeholder="Enter a contact number" v-model="contact_number" :class="{ error: errors.contact_number }">
								<span v-if="errors.contact_number" class="validation-error">{{ errors.contact_number[0] }}</span>
							</p>
							<p>
								<label for="email_address" class="required">Email Address</label>
								<input type="text" id="email_address" name="email_address" placeholder="Enter email address" v-model="email_address" :class="{ error: errors.email_address }">
								<span v-if="errors.email_address" class="validation-error">{{ errors.email_address[0] }}</span>
							</p>
							<p>
								<label for="password" class="required">Password</label>
								<input type="text" id="password" name="password" placeholder="Enter a password" v-model="password" :class="{ error: errors.password }">
								<span v-if="errors.password" class="validation-error">{{ errors.password[0] }}</span>
							</p>
							<p class="half" style="margin-left: auto;">
								<button type="submit" class="button solid arrow wide medium" v-on:click="submitForm()" :style="'--accent:' + this.accent">Submit</button>
							</p>
						</div>

					</div>
				</section>

			</div>
		</div>
	 </transition-group>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
export default {
	
	props: [
		'accent',
		'uuid'
	],

	data: () => {
		return {
			csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
			participant_id: null,
			first_name: '',
			last_name: '',
			contact_number: '',
			email_address: '',
			password: '',
			errors: [],
			shouldShow: false
		}
	},

	computed: {
	},

	watch: {
	},

	created() {
	},

	mounted() {
	},

	methods: {

		...mapActions(['addAlert']),

		wrap: function(el, wrapper) {
			el.parentNode.insertBefore(wrapper, el);
			wrapper.appendChild(el);
		},

		toggleClaimForm: function(){
			if(this.shouldShow==true) {
				this.shouldShow = false;
				this.success = false;
				this.errors = [];

			}else{
				this.shouldShow = true;
				this.$nextTick(function() {
				});
			}
		},

		submitForm: function() {
			var self = this;
			axios.post('/ajax/postClaimForm', {
				uuid: this.uuid,
				first_name: this.first_name,
				last_name: this.last_name,
				contact_number: this.contact_number,
				email_address: this.email_address,
				password: this.password
			})
			.then(response => {
				if(response.data.status=='success') {
					this.$root.$refs.claim_place.getParticipantList();
					this.$root.$refs.claim_place.updateAvailableSpaces(response.data.available_spaces);
					this.$root.$refs.claim_place.hideClaimButton();
					this.shouldShow = false;
					var self = this;
					setTimeout(function() {
						self.alert("<strong>Great!</strong> You've claimed your place", 'success')
					}, 500);
					setTimeout(function() {
						// redirect to proper account page
						window.location.href = "/account/bookings/" + response.data.reference;
					}, 2000);
				}else{
					this.errors = response.data['errors'];
					document.getElementById('claim_form').scrollIntoView({behavior: "smooth"});
				}
			})
			.catch(error => {
				if(error.response.status == 422) {
					var errors = error.response.data['errors'];
					this.errors = errors;
					document.getElementById('claim_form').scrollIntoView({behavior: "smooth"});
				}
			});

		},

		skipForm: function() {
			var self = this;
			axios.post('/ajax/skipClaimForm', {
				uuid: this.uuid
			})
			.then(response => {
				if(response.data.status=='success') {
					this.$root.$refs.claim_place.getParticipantList();
					this.$root.$refs.claim_place.updateAvailableSpaces(response.data.available_spaces);
					this.$root.$refs.claim_place.hideClaimButton();
					this.shouldShow = false;
					var self = this;
					setTimeout(function() {
						self.alert("<strong>Great!</strong> You've claimed your place", 'success')
					}, 500);
					setTimeout(function() {
						// redirect to proper account page
						window.location.href = "/account/bookings/" + response.data.reference;
					}, 2000);
				}else{
					this.errors = response.data['errors'];
					document.getElementById('claim_form').scrollIntoView({behavior: "smooth"});
				}
			})
			.catch(error => {
				if(error.response.status == 422) {
					var errors = error.response.data['errors'];
					this.errors = errors;
					document.getElementById('claim_form').scrollIntoView({behavior: "smooth"});
				}
			});

		},

		alert: function(message, type, important = false) {
			this.addAlert({
				alertClass: 'alert-' + type, 
				alertMessage: message, 
				alertImportant: important,
			});
		},

	}
};
</script>